import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translations from "translations";

i18n.use(initReactI18next).init({
  resources: translations,
  lng: "en", // Default language
  fallbackLng: "en", // Fallback language if the selected language is unavailable
  keySeparator: false, // Not using nested keys in translations
  interpolation: {
    escapeValue: false, // React already escapes strings to prevent XSS
  },
});

export default i18n;
